import React from 'react';
import { motion } from 'framer-motion';
import ProductCard from './ProductCard';

const ProductSection = ({ title, products, id, onAddToCart }) => {
  return (
    <section id={id} className="py-24 md:py-32 px-6 max-w-7xl mx-auto" aria-labelledby={`${id}-heading`}>
      <div className="text-center mb-16 md:mb-20">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <h2 id={`${id}-heading`} className="text-3xl md:text-5xl font-serif text-plum-dark mb-6">{title}</h2>
          <div className="w-12 h-[2px] bg-jade mx-auto" aria-hidden="true"></div>
        </motion.div>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
        {products.map((product, index) => (
          <motion.div
            key={product.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.8, delay: index * 0.15 }}
          >
            <ProductCard product={product} onAddToCart={onAddToCart} />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProductSection;